import Quill from 'quill';

import LinkToolbar from './toolbar';
import LinkFormat from './format';
import LinkClass from './class';

import './scss/quill-link.sass';

Quill.register(
    {
        'formats/link': LinkFormat,
        'modules/link': LinkToolbar,
        'attributors/class/link': LinkClass
    },
    true
);

export default { LinkFormat, LinkToolbar };
